module.exports = __webpack_public_path__ + "assets/img/img339.626e93e6.png";